export enum UpsellKeys {
  GoPremiumClicked = "GoPremiumClicked",
  GoPremiumDialogShown = "GoPremiumDialogShown"
};